import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Coffee } from 'lucide-react';
export function Hero() {
  return <section className="relative h-screen w-full overflow-hidden bg-[#0a0a0a]" data-id="element-45" data-mp="ej4nhxerobfg">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-46" data-mp="9ipaj6yed5y0">
        <img src="https://images.unsplash.com/photo-1497935586351-b67a49e012bf?q=80&w=2671&auto=format&fit=crop" alt="Coffee texture background" className="w-full h-full object-cover opacity-40 grayscale contrast-125" data-id="element-47" data-mp="4m8kg77n0hia" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-transparent to-black/80" data-id="element-48" data-mp="x8b6zmndx72b" />
        {/* Grain/Texture Overlay */}
        <div className="absolute inset-0 opacity-20 bg-[url('https://www.transparenttextures.com/patterns/concrete-wall.png')] mix-blend-overlay" data-id="element-49" data-mp="ncq4lneem4s1" />
      </div>

      {/* Vertical Sidebar Text (Desktop) */}
      <div className="hidden lg:flex absolute right-0 top-0 bottom-0 w-24 z-20 items-center justify-center border-l border-white/10 bg-black/20 backdrop-blur-sm" data-id="element-50" data-mp="3825xcnx6o3kb">
        <div className="text-vertical rotate-180 flex items-center gap-8 text-white/80 font-bebas tracking-widest text-lg" data-id="element-51" data-mp="3o7ls3r2jl6oy">
          <span className="text-[#D97E3A]" data-id="element-52" data-mp="39aurjeh4toxr">OPEN DAILY 7AM - 2PM</span>
          <span className="w-px h-12 bg-white/30" data-id="element-53" data-mp="39cpfz2rm3z6l"></span>
          <span data-id="element-54" data-mp="3e84m18jdoqsg">925.292.0433</span>
          <span className="w-px h-12 bg-white/30" data-id="element-55" data-mp="3eb8zkwiqgyvs"></span>
          <span data-id="element-56" data-mp="30h9blrt8e1mr">LIVERMORE, CA</span>
        </div>
      </div>

      {/* Main Content */}
      <div className="relative z-10 h-full flex flex-col justify-center px-6 md:px-12 lg:px-24 max-w-[1800px] mx-auto" data-id="element-57" data-mp="358zu4l2bnvp9">
        <motion.div initial={{
        opacity: 0,
        y: 50
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="flex flex-col" data-id="element-58" data-mp="2qlep2llvzmep">
          {/* Brand Tag */}
          <div className="flex items-center gap-3 mb-6" data-id="element-59" data-mp="s21gc6a6u3xc">
            <div className="h-px w-12 bg-[#D97E3A]" data-id="element-60" data-mp="s3md82jz5yyd"></div>
            <span className="text-[#D97E3A] font-inter font-medium tracking-widest text-sm uppercase" data-id="element-61" data-mp="nat83dklgolr">
              Est. 2023
            </span>
          </div>

          {/* Massive Headline */}
          <h1 className="font-bebas text-white leading-[0.85] tracking-tight" data-id="element-62" data-mp="ddf082cql852">
            <span className="block text-[15vw] lg:text-[12rem]" data-id="element-63" data-mp="1b0vx1kt7peg5">COFFEE IS</span>
            <span className="block text-[15vw] lg:text-[12rem] text-transparent bg-clip-text bg-gradient-to-r from-white via-white to-white/50" data-id="element-64" data-mp="1ayt8z6bmdve2">
              COMMUNITY
            </span>
          </h1>

          {/* Tagline & CTAs */}
          <div className="mt-8 md:mt-12 flex flex-col md:flex-row items-start md:items-end gap-8 md:gap-16" data-id="element-65" data-mp="x1ecjhmy8ncl">
            <p className="text-white/80 font-inter text-lg md:text-xl max-w-md leading-relaxed border-l-2 border-[#D97E3A] pl-6" data-id="element-66" data-mp="3ltgojuoc2yqg">
              A neighborhood coffee shop, by neighborhood folks.
              <br data-id="element-67" data-mp="1x9ukg9uwtbmw" />
              <br data-id="element-68" data-mp="1xacf521xbhsp" />
              Dedicated to fostering community.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto" data-id="element-69" data-mp="21a4sds29ic4e">
              <motion.a href="https://order.dripos.com/Grounded-Livermore" target="_blank" rel="noopener noreferrer" whileHover={{
              scale: 1.05
            }} whileTap={{
              scale: 0.95
            }} className="bg-[#D97E3A] text-white px-8 py-4 font-bebas text-xl tracking-wide hover:bg-[#c06b2e] transition-colors flex items-center justify-center gap-2" data-id="element-70" data-mp="26a9afmitjewq">
                ORDER NOW
                <Coffee size={20} data-id="element-71" data-mp="2tyadifx8a34r" />
              </motion.a>

              <motion.button whileHover={{
              scale: 1.05,
              backgroundColor: 'rgba(255,255,255,0.1)'
            }} whileTap={{
              scale: 0.95
            }} className="border border-white text-white px-8 py-4 font-bebas text-xl tracking-wide hover:border-[#D97E3A] hover:text-[#D97E3A] transition-colors flex items-center justify-center gap-2" data-id="element-72" data-mp="umpopxvmbeww">
                ABOUT US
                <ArrowRight size={20} data-id="element-73" data-mp="9ah291e38hx4" />
              </motion.button>
            </div>
          </div>
        </motion.div>
      </div>

      {/* Scroll Indicator */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1,
      duration: 1
    }} className="absolute bottom-8 left-1/2 -translate-x-1/2 z-20 flex flex-col items-center gap-2 text-white/50" data-id="element-74" data-mp="3hqk0yhn82w9b">
        <span className="text-[10px] uppercase tracking-widest font-inter" data-id="element-75" data-mp="3mnir6p3rmj28">
          Scroll
        </span>
        <div className="w-px h-12 bg-gradient-to-b from-white/50 to-transparent" data-id="element-76" data-mp="2u0pnbxv2x3o0"></div>
      </motion.div>
    </section>;
}